import React, { useState } from 'react';
import testimonials from '../data/testimonials.json';
import '../style/testimonialSlider.css'; 

const TestimonialSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
    );
  };

  const { quote, rating, author } = testimonials[currentIndex];

  return (
    <div className="testimonial-slider">
      <button className="slider-button prev" onClick={handlePrev}>
        &#8249;
      </button>
      <div className="testimonial-content">
        <p className="quote">"{quote}"</p>
        <p className="rating">Rating: {rating}</p>
        <p className="author">{author}</p>
      </div>
      <button className="slider-button next" onClick={handleNext}>
        &#8250;
      </button>
      <div className="dots">
        {testimonials.map((_, index) => (
          <span
            key={index}
            className={`dot ${index === currentIndex ? 'active' : ''}`}
            onClick={() => setCurrentIndex(index)}
          ></span>
        ))}
      </div>
    </div>
  );
};

export default TestimonialSlider;